<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col>
                    <b-col><h4>Orders</h4></b-col>
                    <b-col></b-col>
                    <b-col></b-col>
                </b-col>
                <transition name="fade">
                    <div v-if="performingRequest" class="loading">
                        <p>Loading ...</p>
                    </div>
                </transition>

            </b-row>
            <b-row>
                <b-col>
                    <b-pagination  size="sm"
                        v-model="currentPage"
                        :total-rows="totalLength"
                        :per-page="perPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    ></b-pagination>
                </b-col>
                <b-col>
                        <b-form-group  label-size="sm" 
                            label-cols-sm="6"
                            label="Per Page"
                            label-align-sm="right"
                            label-for="size"
                            style="width:auto"
                            >
                            <b-form-select size="sm"
                                style="width:auto"
                            id="size"
                            v-model="perPage"
                            :options="pageOptions"
                            ></b-form-select>
                        </b-form-group>
                </b-col>
            </b-row>
            <!-- Iterate over all items -->
            <b-row>
                <b-col>
                    <table class = 'table' >
                        <thead>
                            <tr class="thead-dark">
                                <th ><h5> Date</h5> </th>
                                <th > <h5> Beer </h5></th>
                                <th > <h5> Status </h5></th>
                                <th> <h5> Delivery </h5></th>
                                <th> <h5> Delivery Method</h5></th>
                                <th> <h5> Actions</h5></th>
                                <th> <h5> Invoice</h5></th>
                            </tr>
                        </thead>

                        <tbody>
                            <!-- Iterate over all orders -->
                            <template  v-for="(item) in getDisplayArray" >
                                <!-- Check if order edited by seller -->
                                <tr v-if="item.suggestedstatus==1&&item.status==0" :key="item.suborderid+'editedorder'">
                                    <td colspan='12' style="color:red">
                                        Original Order: {{item.beerName}}, {{item.brewery}} is suggesting <strong>{{item.suggestedbeername}}</strong> instead
                                        <br>
                                        <b-button @click='acceptChange(item)' variant='success'>Accept This Change</b-button>
                                        <b-button  @click='rejectChange(item)' style="margin-left:10px" variant='outline-danger'>Reject This Change</b-button>
                                        <br>
                                        {{item.sellernote}} 
                                    </td>
                                </tr>
                                <tr :key='item.suborderid'>
                                    <td>                                    
                                        <h4>{{item.dateObject.date}}</h4>
                                        <h6>{{item.dateObject.month}}</h6>
                                    </td>
                                    <td @click="getBeer(item.beerId, item)" style="cursor:pointer; color:#2e5189">
                                        <h5>{{item.brewer}}</h5><h6>{{item.orderQuantity}} {{item.beerName}}</h6>
                                    </td>
                                    <td>
                                        <div v-if='item.status==-1' style='color:red;'>
                                            <h5>{{item.displayStatus}}</h5>
                                            {{item.cancelMessage}}
                                        </div>
                                        <div v-else>
                                            {{item.displayStatus}}
                                        </div>
                                        </td>
                                    <td>
                                        <div v-if='item.status!=-1'>
                                        {{item.deliveryTime}}
                                        </div>

                                    </td>
                                    <td>
                                        <div v-if='item.status!=-1'>
                                        {{item.deliveryMethod}}
                                        </div>

                                    </td>
                                    <!-- Buttons -->
                                    <td>
                                        <b-button-group style='margin-top:10px;'>
                                            <!-- Message -->
                                            <b-button v-b-modal="'SendMsg' + item.suborderid" v-b-tooltip.hover :title="'Message '+item.brewer" 
                                                            class='btn btn-success action-buttons'><i><font-awesome-icon icon="comment" /></i>
                                            </b-button>
                                                        
                                            <b-modal :id="'SendMsg' + item.suborderid" title="Send a Message"  hide-footer>
                                                <sendmessage  :receiverId="item.brewerid" :receiverName = "item.brewer" :arrayDefaultMessages="arrayDefaultMessages"/>
                                            </b-modal>
                                            
                                            <!-- Cancel -->
                                            <b-button v-if = "item.status==0||item.status==1" v-b-modal="'Cancelorder' + item.suborderid" v-b-tooltip.hover title="Cancel Order" 
                                                class='btn btn-danger action-buttons'><i><font-awesome-icon icon="times" /></i>
                                            </b-button>
                                            <b-modal :id="'Cancelorder' + item.suborderid" title="Cancel Order" 
                                                ok-title ='Yes, Cancel Order' :ok-disabled='!cancelMessage'  cancel-title ='Do Not Cancel Order'  @ok="cancelOrder(item.suborderid, item.brewerid, item.beerName, item)">
                                                <p class="my-4">Cancel Order?</p>
                                                <textarea class="form-control"  v-model.trim="cancelMessage" type="text" placeholder="Please enter a reason for cancelling this order" > </textarea>
                                            </b-modal> 
                                        </b-button-group>
                                        </td>

                                        <!-- Invoice -->
                                        <td v-if="item.invoiced">
                                            <small>Invoice Number <br> {{item.invoicenumber}}</small>
                                            <br>
                                            <b-button variant="outline-secondary" @click="showInvoiceNumber(item.invoicenumber)">
                                                Show Invoice
                                            </b-button>
                                            <br>
                                        </td>
                                        <td v-if="!item.invoiced&&item.status!=-1">
                                            <small>Awaiting invoice</small>
                                        </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </b-col>
            </b-row>

            <!-- Beer modal -->
            <b-modal no-fade size="l" id='modal-beer' ok-title="Close" ok-only >
                <beercomponent :beer="selectedBeer" :shouldShowSearch="true" :sentFromCarousel='false' :showCartSidebar='showCartSidebar'/>
            </b-modal>

        <!------------------>
        <!-- Cart sidebar -->
        <!------------------>
        <div>
            <b-sidebar id="sidebar-cart" title="Cart" right shadow v-model="showSideBar" backdrop-variant="dark" backdrop>
                <Cartsidebar  />
            </b-sidebar>
        </div>

        </b-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    import { currentUser } from '../firebaseConfig'
    const fb = require('../firebaseConfig.js')
    import {cancelorderupdateinventory} from './Myfunctions'
    import {timeConverter} from './Myfunctions'
    import {timeConverterDateOnly} from './Myfunctions'
    import {timeConverterObject} from './Myfunctions'
    import Breweryreviews from './Breweryreviews'
    import Sendmessage from './Sendmessage'
    import {sendnotification} from './Myfunctions'

    import Beercomponent from './Beercomponent'
    import Cartsidebar from './buyer/Cartsidebar'

    export default {
        components: {
                Sendmessage,
                Breweryreviews,
                Beercomponent,
                Cartsidebar,
            },


        data() {
            return {
                beer:{
                    beerName:'',
                    quantity:'',
                    abv:'',
                    type:'',
                    description:''
                },
                showSuccess: false,
                allOrders:[],
                performingRequest:false,
                cancelMessage:'',
                arrayDefaultMessages:[
                    'Could you please send me some samples',
                    'Could you please let me know the status of my order'
                ],
                currentPage:1,
                perPage:10,
                totalLength:'',
                pageOptions: [
                    { value: '10', text: '10' },
                    { value: '25', text: '25' },
                    { value: '50', text: '50' },
                    { value: '9999999999999', text: 'All' },
                    ],
                selectedBeer:{},
                showSideBar:false,

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser']),
            getDisplayArray: function () {
                
                var localDisplayArray
                localDisplayArray = this.allOrders

                var paginatedList = []
                this.totalLength = localDisplayArray.length
                var indexStart = (parseInt(this.currentPage-1))*parseInt(this.perPage)
                var indexStop = indexStart + parseInt(this.perPage)

                if (indexStop>localDisplayArray.length) indexStop = localDisplayArray.length
                for (var k = indexStart; k<indexStop; k++){
                    paginatedList.push(localDisplayArray[k])
                }

                //console.log(paginatedList)
                return paginatedList
            },

        },


        methods: {
            //Get user orders
            fetchOrders() {
                fb.ordersCollection.where('pubid', '==', this.currentUser.uid).orderBy("createdOn", "desc").onSnapshot(querySnapshot => {
                    let orderArray = []
                    this.allOrders=[]
                    querySnapshot.forEach(doc => {
                           let order = doc.data()
                           order.docId = doc.id
                           if (order.deliveryDate)
                                order.deliveryTime = timeConverterDateOnly(order.deliveryDate.seconds)
                            else
                                order.deliveryTime ="Pending"

                            if (order.createdOn) {
                                order.orderDate = timeConverter(order.createdOn.seconds)
                                order.dateObject = timeConverterObject(order.createdOn.seconds)
                                //order.orderDate = moment(String(Date(order.createdOn))).format('LLLL')
                            }
                            if(order.status==0||order.status==1){
                                order.enableCancelButton=1
                            }
                            else{
                                order.enableCancelButton=0
                            }

                            switch(parseInt(order.status)) {
                                case -1:
                                    if(order.cancelledBy == 0){
                                        if(order.cancelMessage) var adStr = order.brewer
                                        else var adStr = order.brewer
                                        
                                    }
                                    else{
                                        var adStr = order.pub
                                    }
                                    order.displayStatus="Cancelled by " + adStr
                                    break;
                                case 0:
                                    order.displayStatus="Pending"
                                    break;
                                case 1:
                                    order.displayStatus="Accepted"
                                    break;
                                case 2:
                                    order.displayStatus="On It's Way!"
                                    break;
                                default:
                                    order.displayStatus="Pending"
                                } 
                             
                            orderArray.push(order)
                            this.allOrders = orderArray
                            this.performingRequest=false
                        })
                    })

            },

        cancelOrder(suborderid, brewerId, beerName, order){
            cancelorderupdateinventory(suborderid, 1, this.cancelMessage)
            //Send email to brewer
            var subject = this.userProfile.company + ' cancelled order for ' + beerName
            var text = this.userProfile.company +' cancelled order for ' + beerName + ' because ' + this.cancelMessage

            // Add to news feed
            var feedString
            var feedObject = {}
            feedObject.brewerId = brewerId
            feedObject.pubId = this.currentUser.uid
            feedString = this.userProfile.company + ' cancelled ' + beerName + ' Because: ' + this.cancelMessage
            feedObject.feedString = feedString
            this.$store.dispatch('addToNewsFeed',feedObject)
            this.cancelMessage=''

            sendnotification(brewerId, feedString)

            },
            //Show an invoice
            showInvoiceNumber(invoicenumber){
                this.$router.push({ path: 'showinvoice', query: { invoicenumber: invoicenumber }})
            },

            //Get beer, when clicked on order
            getBeer(beerId, order){
                //Check if this was manually edited to suggest new beer
                if(order.manualbeer==1) return
                
                console.log("Getting beer id " + beerId)
                this.performingRequest=true
                fb.beersCollection.doc(beerId).get().then((doc) => {
                    if (doc.exists) {
                        console.log("Document data:", doc.data());
                        this.selectedBeer = doc.data()
                        this.selectedBeer.docId = doc.id
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                })
                .then(doc => {
                    console.log("Got the beer")
                    this.performingRequest=false
                    this.showBeerModal()
                })
                
                .catch((error) => {
                    console.log("Error getting document:", error);
                    this.performingRequest=false
                });
            },

            //Show beer modal
            showBeerModal(){
                console.log("Showing beer modal")
                this.$bvModal.show("modal-beer")
            },

            //Show cart sidebar
            showCartSidebar(){
                this.$bvModal.hide("modal-beer")
                this.showSideBar=true
            },

            //Accept change to order
            acceptChange(item){
                console.log("Accepting change")
                var localOrder = item
                localOrder.suggestedstatus=2
                localOrder.status=1
                //Save original order
                localOrder.origbeername=localOrder.beerName
                localOrder.origbeerid=localOrder.beerId
                localOrder.origsize=localOrder.size
                localOrder.origcost=localOrder.cost

                //Modify to new order
                localOrder.beerName=localOrder.suggestedbeername
                localOrder.beerId=localOrder.suggestedbeerid
                localOrder.cost=localOrder.suggestedcost
                localOrder.size=localOrder.suggestedsize
                fb.ordersCollection.doc(localOrder.docId).update(localOrder)

            },

            //Reject change to order
            rejectChange(item){
                console.log("Rejecting change")
                this.cancelMessage=this.userProfile.company + ' rejected change to ' + item.suggestedbeername
                console.log("message: " + this.cancelMessage)
                //Update status and cancel order
                fb.ordersCollection.doc(item.docId).update({suggestedstatus:3, status:-1})
                this.cancelOrder(item.suborderid, item.brewerid, item.beerName, item)

            },


        },

    mounted(){
            this.fetchOrders()
        }
        

    }
</script>
<style>
.my-col3{
    border:10px solid black;
}
.my-col4{
    border:10px solid green;
}

.my-col5{
    border:2px solid red;
}
.action-buttons{
    margin-left: 4px !important;
}

</style>
